export const SESSIONUSERS_CHANGED = 'SESSIONUSERS_CHANGED';

export const SESSIONUSER_UPDATE_PERCENTAGE_REQUEST = 'SESSIONUSER_UPDATE_PERCENTAGE_REQUEST';
export const SESSIONUSER_UPDATE_PERCENTAGE_UPDATE = 'SESSIONUSER_UPDATE_PERCENTAGE_UPDATE';
export const SESSIONUSER_UPDATE_PERCENTAGE_SUCCESS = 'SESSIONUSER_UPDATE_PERCENTAGE_SUCCESS';
export const SESSIONUSER_UPDATE_PERCENTAGE_ERROR = 'SESSIONUSER_UPDATE_PERCENTAGE_ERROR';
